import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import ReactMarkdown from "react-markdown";
import { ActionBar } from "@/lib/components/ActionBar";
import { ImageSlider } from "@/lib/components/common/ImageSlider";
import { FeatureCard } from "@/lib/components/FeatureCard";
import { PlaceMiniMap } from "@/lib/components/map/PlaceMiniMap";
import { useIsAdmin } from "@/lib/hooks/useIsAdmin";
import { trpc } from "@/router";

// ─── Place card (shown on experience detail) ────────────────────────────────
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function PlaceCard(t0) {
  const $ = _c(41);
  const {
    placeId
  } = t0;
  let t1;
  if ($[0] !== placeId) {
    t1 = trpc.places.byId.queryOptions({
      id: placeId
    });
    $[0] = placeId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: place,
    isPending
  } = useQuery(t1);
  let t2;
  if ($[2] !== placeId) {
    t2 = trpc.places.byIdFull.queryOptions({
      id: placeId
    });
    $[2] = placeId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data: fullPlace
  } = useQuery(t2);
  if (!place) {
    if (!isPending) {
      return null;
    }
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = /*#__PURE__*/_jsx("div", {
        className: "mt-10 h-48 animate-pulse rounded-xl border bg-gray-100"
      });
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[5] !== fullPlace?.features || $[6] !== place.categoryName || $[7] !== place.location.latitude || $[8] !== place.location.longitude || $[9] !== place.name || $[10] !== placeId) {
    const features = fullPlace?.features ?? [];
    const featurePins = features.filter(_temp).map(_temp2);
    t6 = "mt-10 overflow-hidden rounded-xl border";
    t7 = /*#__PURE__*/_jsx("div", {
      className: "h-40",
      children: /*#__PURE__*/_jsx(PlaceMiniMap, {
        latitude: place.location.latitude,
        longitude: place.location.longitude,
        features: featurePins
      })
    });
    t3 = "bg-white p-4";
    const t8 = String(placeId);
    let t9;
    if ($[16] !== t8) {
      t9 = {
        id: t8
      };
      $[16] = t8;
      $[17] = t9;
    } else {
      t9 = $[17];
    }
    let t10;
    if ($[18] !== place.name) {
      t10 = /*#__PURE__*/_jsx("h3", {
        className: "text-lg font-bold text-gray-900 group-hover:text-brand",
        children: place.name
      });
      $[18] = place.name;
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    let t11;
    if ($[20] !== place.categoryName) {
      t11 = place.categoryName && /*#__PURE__*/_jsx("p", {
        className: "text-sm text-gray-500",
        children: place.categoryName
      });
      $[20] = place.categoryName;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    if ($[22] !== t10 || $[23] !== t11 || $[24] !== t9) {
      t4 = /*#__PURE__*/_jsxs(Link, {
        to: "/plats/$id",
        params: t9,
        className: "group",
        children: [t10, t11]
      });
      $[22] = t10;
      $[23] = t11;
      $[24] = t9;
      $[25] = t4;
    } else {
      t4 = $[25];
    }
    t5 = features.length > 0 && /*#__PURE__*/_jsxs("div", {
      className: "mt-3 space-y-1.5",
      children: [features.slice(0, 3).map(_temp3), features.length > 3 && /*#__PURE__*/_jsxs("p", {
        className: "text-xs text-gray-400",
        children: ["+", features.length - 3, " fler"]
      })]
    });
    $[5] = fullPlace?.features;
    $[6] = place.categoryName;
    $[7] = place.location.latitude;
    $[8] = place.location.longitude;
    $[9] = place.name;
    $[10] = placeId;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
  }
  let t8;
  if ($[26] !== place.name || $[27] !== placeId) {
    t8 = {
      placeId,
      placeName: place.name
    };
    $[26] = place.name;
    $[27] = placeId;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== place.location || $[30] !== t8) {
    t9 = /*#__PURE__*/_jsx("div", {
      className: "mt-3",
      children: /*#__PURE__*/_jsx(ActionBar, {
        location: place.location,
        bidra: t8
      })
    });
    $[29] = place.location;
    $[30] = t8;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] !== t3 || $[33] !== t4 || $[34] !== t5 || $[35] !== t9) {
    t10 = /*#__PURE__*/_jsxs("div", {
      className: t3,
      children: [t4, t5, t9]
    });
    $[32] = t3;
    $[33] = t4;
    $[34] = t5;
    $[35] = t9;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  let t11;
  if ($[37] !== t10 || $[38] !== t6 || $[39] !== t7) {
    t11 = /*#__PURE__*/_jsxs("div", {
      className: t6,
      children: [t7, t10]
    });
    $[37] = t10;
    $[38] = t6;
    $[39] = t7;
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  return t11;
}

// ─── Main view ──────────────────────────────────────────────────────────────
function _temp3(f_1) {
  return /*#__PURE__*/_jsx(FeatureCard, {
    feature: f_1
  }, f_1.id);
}
function _temp2(f_0) {
  return {
    id: f_0.id,
    label: f_0.featureType?.name ?? "Entr\xE9",
    latitude: f_0.location.latitude,
    longitude: f_0.location.longitude,
    status: f_0.status
  };
}
function _temp(f) {
  return f.location;
}
export function ExperienceDetailView(t0) {
  const $ = _c(37);
  const {
    experience
  } = t0;
  const isAdmin = useIsAdmin();
  let t1;
  if ($[0] !== experience.media || $[1] !== experience.title) {
    let t2;
    if ($[3] !== experience.title) {
      t2 = m => ({
        url: m.url,
        altText: m.altText ?? experience.title
      });
      $[3] = experience.title;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = experience.media.map(t2);
    $[0] = experience.media;
    $[1] = experience.title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const images = t1;
  let t2;
  if ($[5] !== experience.title || $[6] !== images) {
    t2 = images.length > 0 && /*#__PURE__*/_jsx("div", {
      className: "relative h-[min(50vh,24rem)] w-full bg-gray-100",
      children: /*#__PURE__*/_jsx(ImageSlider, {
        images: images,
        title: experience.title,
        className: "h-full"
      })
    });
    $[5] = experience.title;
    $[6] = images;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = /*#__PURE__*/_jsxs(Link, {
      to: "/upptack",
      className: "mb-4 inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-700",
      children: [/*#__PURE__*/_jsx(ArrowLeft, {
        className: "h-4 w-4"
      }), "Alla upplevelser"]
    });
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== experience.title) {
    t4 = /*#__PURE__*/_jsx("h1", {
      className: "text-2xl font-bold text-gray-900 sm:text-3xl",
      children: experience.title
    });
    $[9] = experience.title;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== experience.subtitle) {
    t5 = experience.subtitle && /*#__PURE__*/_jsx("p", {
      className: "mt-2 text-lg text-gray-600",
      children: experience.subtitle
    });
    $[11] = experience.subtitle;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== experience.isPublished) {
    t6 = !experience.isPublished && /*#__PURE__*/_jsx("span", {
      className: "rounded-full bg-amber-100 px-2.5 py-0.5 text-xs font-medium text-amber-700",
      children: "Utkast"
    });
    $[13] = experience.isPublished;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== experience.id || $[16] !== experience.titleSlug || $[17] !== isAdmin) {
    t7 = isAdmin ? {
      to: "/upptack/redigera/$slug",
      params: {
        slug: experience.titleSlug ?? experience.id
      }
    } : undefined;
    $[15] = experience.id;
    $[16] = experience.titleSlug;
    $[17] = isAdmin;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t7) {
    t8 = /*#__PURE__*/_jsx(ActionBar, {
      share: true,
      editLink: t7
    });
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t6 || $[22] !== t8) {
    t9 = /*#__PURE__*/_jsxs("div", {
      className: "mt-4 flex flex-wrap items-center gap-3",
      children: [t6, t8]
    });
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== experience.description) {
    t10 = experience.description && /*#__PURE__*/_jsx("div", {
      className: "prose prose-gray mt-8 max-w-none",
      children: /*#__PURE__*/_jsx(ReactMarkdown, {
        components: markdownComponents,
        children: experience.description
      })
    });
    $[24] = experience.description;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== experience.placeId) {
    t11 = experience.placeId && /*#__PURE__*/_jsx(PlaceCard, {
      placeId: experience.placeId
    });
    $[26] = experience.placeId;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t10 || $[29] !== t11 || $[30] !== t4 || $[31] !== t5 || $[32] !== t9) {
    t12 = /*#__PURE__*/_jsxs("div", {
      className: "mx-auto max-w-3xl px-4 py-8 sm:px-6",
      children: [t3, t4, t5, t9, t10, t11]
    });
    $[28] = t10;
    $[29] = t11;
    $[30] = t4;
    $[31] = t5;
    $[32] = t9;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t12 || $[35] !== t2) {
    t13 = /*#__PURE__*/_jsxs("article", {
      className: "min-h-screen bg-white",
      children: [t2, t12]
    });
    $[34] = t12;
    $[35] = t2;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  return t13;
}

// ─── Markdown config ────────────────────────────────────────────────────────

const markdownComponents = {
  h1: ({
    children
  }) => /*#__PURE__*/_jsx("h2", {
    className: "mt-8 mb-4 text-xl font-bold text-gray-900",
    children: children
  }),
  h2: ({
    children
  }) => /*#__PURE__*/_jsx("h3", {
    className: "mt-6 mb-3 text-lg font-bold text-gray-900",
    children: children
  }),
  p: ({
    children
  }) => /*#__PURE__*/_jsx("p", {
    className: "mb-4 leading-relaxed text-gray-700",
    children: children
  }),
  ul: ({
    children
  }) => /*#__PURE__*/_jsx("ul", {
    className: "mb-4 list-disc space-y-1 pl-6 text-gray-700",
    children: children
  }),
  ol: ({
    children
  }) => /*#__PURE__*/_jsx("ol", {
    className: "mb-4 list-decimal space-y-1 pl-6 text-gray-700",
    children: children
  }),
  blockquote: ({
    children
  }) => /*#__PURE__*/_jsx("blockquote", {
    className: "mb-4 border-l-4 border-brand/30 pl-4 italic text-gray-600",
    children: children
  })
};